module.exports = __webpack_public_path__ + "img/zngc.73bcaa25.png";